// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';
import SectionTitle from './SectionTitle';

/**
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {React.ReactElement | string} [props.title]
 * @param {React.ReactElement | string} [props.as]
 * @param {string} [props.variant]
 */
export default function Section({
  children,
  title,
  variant = 'default',
  ...rest
}) {
  return (
    <Box as="section" sx={{ variant: `section.${variant}` }} {...rest}>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </Box>
  );
}
